import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const ImmunizationCard = ({ entity }) => {
  const { name, receivedAt, isPrivate, manufacturer } = entity;
  const safeTitle = manufacturer ? `${name}, (${manufacturer})` : name;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon
            size={28}
            name="icon-vaccines-black"
            className={styles.iconType}
          />
          <div className={styles.contentWrapper}>
            <div className={styles.title}>
              <div className={styles.titleWrapper}>{safeTitle}</div>
              <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
            </div>
            <div className={styles.description}>
              {receivedAt ? formatDate(receivedAt, 'MMM D, Y') : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ImmunizationCard.propTypes = {
  entity: PropTypes.object,
};

export default ImmunizationCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/ImmunizationCard/index.jsx